export enum AllowedActions {
  GET_IT = 'getIt',
  CANCEL = 'cancel',
  FREEZE = 'freeze',
  UNFREEZE = 'unfreeze',
}
